import {ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {AnimationOptions} from 'ngx-lottie';
import {Question} from '../../models/underwriter.model';
import {GlobalQuestionService} from '../../services/global-question.service';
import {FlowPageDataProduct, FlowSummary, QuestionFlowCollation} from '../../models/quote.model';
import {QuestionFlowSessionQuery} from '../state/question-flow-session.query';
import {FlowPlayerService} from '../../services/flow-player.service';
import {QuestionQuery} from '../state/question.query';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {Alert} from '../../../shared/utilities';
import { UserStore } from 'src/app/modules/authentication/state/user.store';
import { ComponentsService } from '../../services/components-service';
import { SuperflowStore } from '../state/superflow.store';
import { SidesheetComponent, SidesheetItem } from '../../components/sidesheet/sidesheet.component';
import { RouterLinks } from '../../constants';

declare var $: any;
declare const Tawk_API: any;

@Component({
    selector: 'app-question-quote',
    templateUrl: './question-quote.component.html',
    styleUrls: ['./question-quote.component.scss'],
    standalone: false
})
export class QuestionQuoteComponent implements OnInit, OnChanges, OnDestroy {

  @ViewChild('benefitsSidesheet') benefitsSidesheet: SidesheetComponent;
  @ViewChild('breakdownSidesheet') breakdownSidesheet: SidesheetComponent;
  @ViewChild('ratingSidesheet') ratingSidesheet: SidesheetComponent;
  @ViewChild('excessesSidesheet') excessesSidesheet: SidesheetComponent;

  @Input() question: Question;
  @Output() questionAnswer = new EventEmitter<any>();
  @Output() submitResponse = new EventEmitter<any>();
  @Output() showEditModal = new EventEmitter<any>();
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onSummaryDataChanged = new EventEmitter<any>();
  @Output() navigateBack = new EventEmitter<void>();

  collations: QuestionFlowCollation[] = [];
  summaryCollations: QuestionFlowCollation[] = [];
  product: FlowPageDataProduct;
  summary = new FlowSummary();
  sessionDetails: any;
  selectedItem: any;
  classes: QuestionFlowCollation[] = [];
  classItems: any[] = [];
  isSavingData = false;
  parameter: any;
  summaryDataSubscription: Subscription;
  recommendation: any;
  user: any;
  window: any['dataLayer'] = window['dataLayer'] || [];
  selectedRecommendation: any
  quotePageData: any;
  products: any[];
  tiers: any[];
  benefitsData: SidesheetItem[] = [];
  breakdownData: SidesheetItem[] = [];
  breakdownTotal: string = '0';
  selectedTierForRating: any = null;
  selectedTierForExcesses: any = null;
  lottieOptions: AnimationOptions = {
    path: 'assets/evi-icon.json',
  };
  selectedProduct: any;
  selectedProducts: any[];
  originalSelectedProducts: any[];
  filterTouched: boolean = false;
  selectedTier: any;
  pageInfo: any;
  quote: any;
  numPlans: number = 3;
  quoteITKs: any = {};
  excessesData: any[] = [];
  chat: any;
  addedBenefits: any[];
  frequencyId: number = 3;
  constructor(
    public questionService: GlobalQuestionService,
    private flowPlayer: FlowPlayerService,
    private ref: ChangeDetectorRef,
    private router: Router,
    private userStore: UserStore,
    private QuestionQuery: QuestionQuery,
    private superflowStore: SuperflowStore,
    private componentsService: ComponentsService,
    private questionFlowSessionQuery: QuestionFlowSessionQuery) {
    this.sessionDetails = this.questionFlowSessionQuery.getValue(); 
    console.log(this.sessionDetails);
  }


  ngOnInit(): void {
    this.chat = Tawk_API;
    this.user = this.userStore.getValue();
    //this.Sidesheet = Sidesheet;
    try {
      this.parameter = JSON.parse(this.question.parameter);
    } catch (e) { }
    const rawData = sessionStorage.getItem('quotePageData');
    if (rawData) {
      const allData: any[][] = JSON.parse(rawData);
      
      // Accessing your datasets based on the image structure:
      //this.quote = allData[0];  // The Array(1) from your image
      this.quotePageData = allData[1]; // The Array(16) from your image

      //console.log('First Dataset:', firstDataset);
      console.log('Second Dataset:', this.quotePageData);
      this.pageInfo = this.quotePageData.find((item: any) => item.entry_type === 'page_info');
      this.selectedTier = this.quotePageData.find((item: any) => item.entry_type === 'product_tier' && item.recommended === 1);
      this.tiers = this.quotePageData.filter((item: any) => item.entry_type === 'product_tier');
      this.quote = this.quotePageData.find((item: any) => item.entry_type === 'overview');
      const recommendedProduct = this.quotePageData.find((item: any) => item.entry_type === 'product' && item.recommended === 1)
        ?? this.quotePageData.find((item: any) => item.entry_type === 'product' && item.frequency_id != null);
      this.frequencyId = recommendedProduct?.frequency_id ?? 3;

      this.products = this.quotePageData
        .filter((item: any) => item.entry_type === 'product' && item.tier_id === this.selectedTier?.tier_id)
        .map((item: any) => ({
          ...item,
          insurer_rating: item.insurer_rating ? JSON.parse(item.insurer_rating) : null,
          benefits: item.benefits ? JSON.parse(item.benefits) : null,
          features: item.features ? JSON.parse(item.features) : null
        }));
      
      if (this.products.length > 3) {
        this.selectedProducts = this.products.slice(0, 3);
        this.numPlans = 3;
      } else {
        this.selectedProducts = [...this.products];
        this.numPlans = this.products.length;
      }
      this.originalSelectedProducts = [...this.selectedProducts];
      console.log('products:', this.selectedProducts);
      setTimeout(() => {
        this.initSliders(this.numPlans);
        // Initialize Bootstrap popovers after slider content is rendered
        this.questionService.initPopoverCustomize();
      }, 100);
       
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.question?.currentValue !== changes?.question?.previousValue) {
      this.question = changes?.question?.currentValue;

    }
  }
  ngAfterViewInit(): void {
    document.querySelector('body')?.classList.add('page--questions');
    document.querySelector('body')?.classList.add('page--questions-no-tray');
    document.querySelector('body')?.classList.add('page--questions-top-aligned');
  }
  initSliders(numPlans: number): void {
    const $chooseSlider = $('#choose-slider');

    const chooseSliderSettings = {
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      prevArrow: '<button type="button" class="slick-prev"><svg class="icon icon--lg"><use xlink:href="#chevron-right"></use></svg></button>',
      nextArrow: '<button type="button" class="slick-next"><svg class="icon icon--lg"><use xlink:href="#chevron-right"></use></svg></button>',
      infinite: false,
      speed: 300,
      swipeToSlide: true,
      mobileFirst: true,
      rows: 0,
      responsive: [{
        breakpoint: 992,
        settings: {
          arrows: numPlans > 3
        }
      }]
    };

    // Initialize slick slider
    $chooseSlider.slick(chooseSliderSettings);

    // Handle 2 slides layout
    if (numPlans === 2) {
      $chooseSlider.addClass('choose-slider--2');
    } else {
      $chooseSlider.removeClass('choose-slider--2');
    }

    // Navigate to appropriate slide
    if (numPlans < 3) {
      $chooseSlider.slick('slickGoTo', 0, false);
    } else if (numPlans >= 3) {
      $chooseSlider.slick('slickGoTo', 1, false);
    }

    // Animate in the slides
    const planSlides = document.querySelectorAll('.choose-slider__slide');
    planSlides.forEach((slide) => {
      slide.addEventListener('animationend', () => {
        slide.classList.remove('animating-in');
      }, { once: true });
      slide.classList.add('animating-in');
    });

    this.questionService.initPopoverCustomize();
  }

  openBenefitsSidesheet(product: any, event: Event): void {
    event.preventDefault();
    this.selectedProduct = product;
     const parameters = new Map<string, string>();
      parameters.set('session_id', this.sessionDetails?.session_id);
      parameters.set('category_id', this.sessionDetails?.category_id);
      parameters.set('product_id', product.product_id);
      parameters.set('frequency_id', this.frequencyId.toString());
      this.questionService.runCommandNew('getAddedBenefits', parameters).subscribe({
        next: (benefits: any[]) => {
          console.log(benefits);
          this.questionService.spinner(false);
          this.addedBenefits = benefits;
        },
        error: () => {
          this.questionService.spinner(false);
        }
      });
    // Transform tier benefits into SidesheetItem format
    // if (product?.benefits) {
    //   this.benefitsData = product.benefits.map((benefit: any) => ({
    //     icon: benefit.img_path || '/assets/icn/class/sm-vehicle.svg',
    //     title: benefit.vaps_name,
    //     price: benefit.limit ? `${benefit.limit}` : null,
    //     priceLabel: '/mo'
    //   }));
    // }
    if (this.benefitsSidesheet) {
      this.benefitsSidesheet.open(event);
      document.body.classList.add('sidesheet-open');
    }
  }

  onBenefitsSidesheetClosed(): void {
    // Optional: handle sidesheet close event
  }

  onBenefitItemSelected(item: SidesheetItem): void {
    // Optional: handle item selection
    console.log('Benefit item selected:', item);
  }

  openBreakdownSidesheet(product: any, event: Event): void {
    event.preventDefault();
    this.selectedProduct = product;

    // Transform tier data into breakdown items
    if (product) {
      this.breakdownData = [];
      //this.questionService.spinner(true);
      const parameters = new Map<string, string>();
      parameters.set('session_id', this.sessionDetails?.session_id);
      parameters.set('category_id', this.sessionDetails?.category_id);
      parameters.set('product_id', product.product_id);
      parameters.set('frequency_id', this.frequencyId.toString());
      this.questionService.runCommandNew('getInsuredItems', parameters).subscribe({
        next: (items: any[]) => {
          this.questionService.spinner(false);
          this.breakdownData = items;
        },
        error: () => {
          this.questionService.spinner(false);
        }
      });
      // Add base premium


      // Add benefits breakdown
      if (product.benefits) {
        product.benefits.forEach((benefit: any) => {
          if (benefit.premium) {
            this.breakdownData.push({
              icon: benefit.img_path,
              title: benefit.vaps_name,
              price: benefit.premium
            });
          }
        });
      }

      // Set total
      this.breakdownTotal = product.premium || '0';
    }
    if (this.breakdownSidesheet) {
      this.breakdownSidesheet.open(event);
      document.body.classList.add('sidesheet-open');
    }
  }

  onBreakdownSidesheetClosed(): void {
    // Optional: handle sidesheet close event
  }

  openRatingSidesheet(product: any, event: Event): void {
    event.preventDefault();
    this.selectedProduct = product;
    if (this.ratingSidesheet) {
      this.ratingSidesheet.open(event);
      document.body.classList.add('sidesheet-open');
    }
  }

  onRatingSidesheetClosed(): void {
    this.selectedProduct = null;
  }

  openExcessesSidesheet(product: any, event: Event): void {
    event.preventDefault();
    this.selectedProduct = product;
    this.excessesData = [];
    //this.questionService.spinner(true);
    const parameters = new Map<string, string>();
    parameters.set('session_id', this.sessionDetails?.session_id);
    parameters.set('product_id', product.product_id);
    parameters.set('frequency_id', this.frequencyId.toString());
    this.questionService.runCommandNew('getExcesses', parameters).subscribe({
      next: (excesses: any[]) => {
        this.questionService.spinner(false);
        this.excessesData = excesses;
      },
      error: () => {
        this.questionService.spinner(false);
      }
    });
    if (this.excessesSidesheet) {
      this.excessesSidesheet.open(event);
      document.body.classList.add('sidesheet-open');
    }
  }

  onExcessesSidesheetClosed(): void {
    this.selectedTierForExcesses = null;
    this.excessesData = [];
  }

  onExcessValueChanged(event: { item: any; newValue: number; clearLoading: () => void }): void {
    const question = new Question();
    question.cent_aq_question_id = event.item.question_id;
    question.cent_aq_question_type_id = event.item.question_type_id;
    question.product_class_id = event.item.class_id;
    question.item_id = event.item.item_id?.toString();
    question.answer = event.newValue?.toString();

    // Store the current product_id and tier_id to restore state after refresh
    const currentProductId = this.selectedProduct?.product_id;
    const currentTierId = this.selectedTier?.tier_id;

    this.questionService.saveAnswerOnly(question).subscribe({
      next: () => {
        // Step 1: Refresh the quote page data
        const parameters = new Map<string, string>();
        parameters.set('session_id', this.sessionDetails.session_id);
        parameters.set('category_id', '3');
        parameters.set('product_group_id', '3');
        parameters.set('page', 'quote');
        parameters.set('user_updated', this.user?.person_id ? this.user.person_id : '0');

        this.questionService.runCommandNew('getQuotePageData', parameters, true).subscribe({
          next: (result: any) => {
            if (result && result.length > 0) {
              // Update session storage
              sessionStorage.setItem('quotePageData', JSON.stringify(result));

              // Update page data
              this.quotePageData = result[1];
              this.pageInfo = this.quotePageData.find((item: any) => item.entry_type === 'page_info');
              this.tiers = this.quotePageData.filter((item: any) => item.entry_type === 'product_tier');
              this.quote = this.quotePageData.find((item: any) => item.entry_type === 'overview');

              // Preserve the tier the user was on, fallback to recommended
              this.selectedTier = currentTierId
                ? this.tiers.find((t: any) => t.tier_id === currentTierId)
                : this.tiers.find((t: any) => t.recommended === 1);

              // Fallback to first tier if neither found
              if (!this.selectedTier && this.tiers.length > 0) {
                this.selectedTier = this.tiers[0];
              }

              this.products = this.quotePageData
                .filter((item: any) => item.entry_type === 'product' && item.tier_id === this.selectedTier?.tier_id)
                .map((item: any) => ({
                  ...item,
                  insurer_rating: item.insurer_rating ? JSON.parse(item.insurer_rating) : null,
                  benefits: item.benefits ? JSON.parse(item.benefits) : null,
                  features: item.features ? JSON.parse(item.features) : null
                }));

              // Find the index of the current product in the full products list
              const currentProductIndex = currentProductId
                ? this.products.findIndex((p: any) => p.product_id === currentProductId)
                : -1;

              // If product exists and is beyond the first 3, adjust selectedProducts to include it
              if (currentProductIndex >= 3 && this.products.length > 3) {
                // Include products around the current one
                const startIndex = Math.max(0, currentProductIndex - 1);
                this.selectedProducts = this.products.slice(startIndex, startIndex + 3);
                this.numPlans = 3;
              } else if (this.products.length > 3) {
                this.selectedProducts = this.products.slice(0, 3);
                this.numPlans = 3;
              } else {
                this.selectedProducts = [...this.products];
                this.numPlans = this.products.length;
              }
              this.originalSelectedProducts = [...this.selectedProducts];

              // Update selectedProduct with new data from refreshed products
              if (currentProductId) {
                const updatedProduct = this.products.find((p: any) => p.product_id === currentProductId);
                if (updatedProduct) {
                  this.selectedProduct = updatedProduct;
                }
              }

              // Destroy existing slider before re-initializing
              this.destroySlider();

              // Find the index of the current product in selectedProducts (after adjustment)
              const productIndex = currentProductId
                ? this.selectedProducts.findIndex((p: any) => p.product_id === currentProductId)
                : -1;

              // Re-initialize sliders
              setTimeout(() => {
                this.initSliders(this.numPlans);
                this.questionService.initPopoverCustomize();

                // Navigate back to the product the user was viewing
                if (productIndex >= 0) {
                  const $chooseSlider = $('#choose-slider');
                  if ($chooseSlider.length && $chooseSlider.hasClass('slick-initialized')) {
                    $chooseSlider.slick('slickGoTo', productIndex, false);
                  }
                }
              }, 100);

              // Step 2: Refresh the excesses sidesheet data
              this.refreshExcessesSidesheet(currentProductId, event.clearLoading);
            } else {
              event.clearLoading();
            }
          },
          error: (err: any) => {
            console.error('getQuotePageData Error:', err);
            event.clearLoading();
          }
        });
      },
      error: (error: any) => {
        console.error('Error updating excess:', error);
        event.clearLoading();
      }
    });
  }

  refreshExcessesSidesheet(productId: string, clearLoading: () => void): void {
    if (!productId) {
      clearLoading();
      return;
    }

    const parameters = new Map<string, string>();
    parameters.set('session_id', this.sessionDetails?.session_id);
    parameters.set('product_id', productId);
    parameters.set('frequency_id', this.frequencyId.toString());

    this.questionService.runCommandNew('getExcesses', parameters).subscribe({
      next: (excesses: any[]) => {
        this.excessesData = excesses;
        clearLoading();
      },
      error: () => {
        clearLoading();
      }
    });
  }

  setSelectedTier(tier: any): void {
    console.log(tier, this.quotePageData);
    this.selectedTier = tier;
    // Destroy existing slider before updating tiers
    const $chooseSlider = $("#choose-slider");
    if ($chooseSlider.length && $chooseSlider.hasClass('slick-initialized')) {
      $chooseSlider.slick('unslick');
    }

    this.products = this.quotePageData
      .filter((tier: any) => tier.entry_type === 'product' && tier.tier_id === this.selectedTier.tier_id)
      .map((item: any) => ({
        ...item,
        insurer_rating: item.insurer_rating ? JSON.parse(item.insurer_rating) : null,
        benefits: item.benefits ? JSON.parse(item.benefits) : null,
        features: item.features ? JSON.parse(item.features) : null
      }));
    
    if (this.products.length > 3) {
      this.selectedProducts = this.products.slice(0, 3);
      this.numPlans = 3;
    } else {
      this.selectedProducts = [...this.products];
      this.numPlans = this.products.length;
    }
    this.originalSelectedProducts = [...this.selectedProducts];
    console.log(this.products);
    setTimeout(() => {
      this.initSliders(this.numPlans);
      // Initialize Bootstrap popovers after slider content is rendered
      this.questionService.initPopoverCustomize();
    }, 100);
  }

  isProductSelected(product: any): boolean {
    return this.selectedProducts.some(p => p.product_id === product.product_id);
  }

  hasSelectionChanged(): boolean {
    if (this.selectedProducts.length !== this.originalSelectedProducts.length) {
      return true;
    }
    return !this.selectedProducts.every(p =>
      this.originalSelectedProducts.some(op => op.product_id === p.product_id)
    );
  }

  setProduct(product: any): void {
    const index = this.selectedProducts.findIndex(p => p.product_id === product.product_id);
    if (index > -1) {
      // Product is already selected, remove it
      this.selectedProducts = this.selectedProducts.filter(p => p.product_id !== product.product_id);
    } else {
      // Product is not selected, add it
      this.selectedProducts = [...this.selectedProducts, product];
    }
    this.numPlans = this.selectedProducts.length;
    this.filterTouched = true;
    console.log(this.selectedProducts);
    this.rebuildSlider();
    this.filterTouched = true;
  }

  private destroySlider(): void {
    const $chooseSlider = $('#choose-slider');
    if ($chooseSlider.length && $chooseSlider.hasClass('slick-initialized')) {
      $chooseSlider.slick('unslick');
    }
  }

  rebuildSlider(): void {
    this.destroySlider();
    this.filterTouched = false;
    setTimeout(() => {
      this.initSliders(this.numPlans);
      this.questionService.initPopoverCustomize();
    }, 100);
  }

 

  getItems(class_id: number): any {
    return this.summaryCollations.filter((item: { class_id: number }) => item.class_id === class_id);
  }

  editItem(collation: QuestionFlowCollation): void {
    //console.log(collation)
    this.showEditModal.emit({
      collations: this.collations,
      collation,
      product: this.product,
      person: this.summary.person,
      path: '3'
    });

    let allQuestions = this.QuestionQuery.getAllQuestions();
    const main_session = {
      session: this.sessionDetails,
      question: this.question,
      questions: allQuestions,
      active_class_id: collation.class_id,
      current_page: 'summary',
    };
    
    localStorage.setItem('main_session', JSON.stringify(main_session));
  }
  checkAddAnother(): boolean {
    try {
      if (this.parameter[1]?.value === 'add_another') {
        return true;
      }
      else {
        return false;
      }
    }
    catch {
      return false;
    }
  }
  gotToNext(): void {
    var a = '';
    try { a = this.parameter[1]?.value } catch (e) { };
    this.question.answer = a;
    this.submitResponse.next(undefined);
  }
  getRecommendation(item: any, class_level: boolean = false): any {
   
    let result: any = [];
     if (class_level) {
        result = this.recommendation.filter(i => i.class_id === item?.class_id && !i.item_id);
     }
     else {
      result = this.recommendation.filter(i => i.class_id === item?.class_id && i.item_id === item.session_item_id);
     }
    return result;
  }
  popUpRecommendation(recommend: any): void {
     this.selectedRecommendation = recommend;
     this.componentsService.setDiscountFlow(this.selectedRecommendation);
     $('#modal-discount-flow').modal('show')
  }
  startFlow(): void {
    console.log(this.selectedRecommendation);

  }

  goBack(): void {
    this.navigateBack.emit();
  }
  groupByClassName(items: any[]): { class_name: string; items: any[] }[] {
    const grouped = items.reduce((acc, item) => {
      const key = item.class_name || 'Other';
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(item);
      return acc;
    }, {} as Record<string, any[]>);

    return Object.keys(grouped).map(class_name => ({
      class_name,
      items: grouped[class_name]
    }));
  }

  getQuoteITKs(product: any): void {
    this.selectedProduct = product;
    //this.questionService.spinner(true);
    const parameters = new Map<string, string>();
    parameters.set('session_id', this.sessionDetails?.session_id);
    parameters.set('product_id', product.product_id);
    parameters.set('frequency_id', this.frequencyId.toString());
    this.questionService.runCommandNew('getQuoteITKs', parameters).subscribe({
      next: (itks: any[]) => {
        
        this.quoteITKs.sub_limits = itks.filter(itk => itk.entry_type === 'sublimit');
        this.quoteITKs.cover = itks.filter(itk => itk.entry_type === 'cover');
        this.quoteITKs.excess = this.groupByClassName(itks.filter(itk => itk.entry_type === 'excess'));
        
        this.questionService.spinner(false);
      },
      error: () => {
        this.questionService.spinner(false);
      }
    });
  }

  viewQuoteSchedule(product: any): void {
    console.log(product);
    window.open(`${RouterLinks.PolicyQuoteSchedule}?quote_id=${this.quote?.quote_id}&product_id=${product?.product_id}&print=false&pdf=false`);
    //this.router.navigateByUrl(`${RouterLinks.PolicyQuoteSchedule}?quote_id=${product?.policy_id}&print=false&pdf=true`);
  }
  onContinue(): void {
    const parameters = new Map<string, string>();
    parameters.set('product_id', this.selectedProduct.product_id.toString());
    parameters.set('session_id', this.sessionDetails.session_id);
    parameters.set('product_group_id', this.sessionDetails.group_id.toString());
    this.questionService.runCommandNew(`updateProductSelected`, parameters).subscribe(res => {
      console.log(res);
      this.question.answer = 'go to quote';
      sessionStorage.setItem('selectedProduct', JSON.stringify(this.selectedProduct));
      this.questionAnswer.emit(this.question);
      this.submitResponse.next(undefined);
    })
  }

  getOverallRating(insurerRating: any[]): number {
    if (!insurerRating?.[0]?.overall_rating) return 0;
    const stars = insurerRating[0].overall_rating.split('|');
    return stars.reduce((sum: number, val: string) => {
      const percent = parseInt(val, 10) || 0;
      return sum + (percent / 100);
    }, 0);
  }
 viewPricingBreakdown(product: any): void {
    if (!product?.price_breakdown_document_id) {
      return;
    }
    localStorage.setItem('previous-document-page', this.router.url);
    this.router.navigate(['/doc-document'], {
      state: {
        doc: { document_id: product.price_breakdown_document_id, document_name: 'Price Breakdown' },
        print: false,
        pdf: false,
        session_id: this.sessionDetails?.session_id,
        referrer_id: '1',
        product
      }
    });
  }
  ngOnDestroy(): void {
    this.summaryDataSubscription?.unsubscribe();
    document.querySelector('body')?.classList.remove('page--questions');
    document.querySelector('body')?.classList.remove('page--questions-no-tray');
    document.querySelector('body')?.classList.remove('page--questions-top-aligned');
  }
}
